import { render } from "./SectionTitle.vue?vue&type=template&id=9fcdd5ce"
const script = {}

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__